function PlanAA({ ...props }) {
	return (
		<g {...props} id="unit-aa">
			<g id="furniture">
				<polyline
					points="765.39 724.75 760.68 724.75 760.68 722.37 765.39 722.37 765.39 724.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="824.74 447.91 824.74 719.98 772.82 719.98 772.82 447.91 824.74 447.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="184.99 447.91 324.49 447.91 324.49 415.46 184.99 415.46 184.99 447.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="184.99"
					y1="415.46"
					x2="184.99"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="415.46"
					x2="184.99"
					y2="415.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="447.91"
					x2="324.49"
					y2="415.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="447.91"
					x2="324.49"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="447.91"
					x2="186.72"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.84"
					y1="447.91"
					x2="195.03"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.15"
					y1="447.91"
					x2="203.34"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.45"
					y1="447.91"
					x2="211.65"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.76"
					y1="447.91"
					x2="219.95"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.07"
					y1="447.91"
					x2="228.26"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.37"
					y1="447.91"
					x2="236.57"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.68"
					y1="447.91"
					x2="244.87"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.99"
					y1="447.91"
					x2="253.18"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.29"
					y1="447.91"
					x2="261.49"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.6"
					y1="447.91"
					x2="269.79"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.91"
					y1="447.91"
					x2="278.1"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.21"
					y1="447.91"
					x2="286.41"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.52"
					y1="447.91"
					x2="294.71"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.83"
					y1="447.91"
					x2="303.02"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.14"
					y1="447.91"
					x2="311.33"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="314.44"
					y1="447.91"
					x2="319.63"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.75"
					y1="447.91"
					x2="324.49"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="447.91"
					x2="324.49"
					y2="442.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="439.52"
					x2="324.49"
					y2="434.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="431.21"
					x2="324.49"
					y2="426.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="422.9"
					x2="324.49"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.49"
					y1="417.62"
					x2="322.75"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.63"
					y1="417.62"
					x2="314.44"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.33"
					y1="417.62"
					x2="306.14"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="417.62"
					x2="297.83"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.71"
					y1="417.62"
					x2="289.52"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.41"
					y1="417.62"
					x2="281.21"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.1"
					y1="417.62"
					x2="272.91"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.79"
					y1="417.62"
					x2="264.6"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.49"
					y1="417.62"
					x2="256.29"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.18"
					y1="417.62"
					x2="247.99"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.87"
					y1="417.62"
					x2="239.68"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.57"
					y1="417.62"
					x2="231.37"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.26"
					y1="417.62"
					x2="223.07"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.95"
					y1="417.62"
					x2="214.76"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.65"
					y1="417.62"
					x2="206.45"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.34"
					y1="417.62"
					x2="198.15"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.03"
					y1="417.62"
					x2="189.84"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.72"
					y1="417.62"
					x2="184.99"
					y2="417.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="417.62"
					x2="184.99"
					y2="422.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="426.02"
					x2="184.99"
					y2="431.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="434.33"
					x2="184.99"
					y2="439.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.99"
					y1="442.63"
					x2="184.99"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="455.21 663.41 616.88 663.41 616.88 630.97 455.21 630.97 455.21 663.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="455.21"
					y1="630.97"
					x2="455.21"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="630.97"
					x2="455.21"
					y2="630.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="663.41"
					x2="616.88"
					y2="630.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="663.41"
					x2="616.88"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="663.41"
					x2="459.73"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.84"
					y1="663.41"
					x2="468.03"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.15"
					y1="663.41"
					x2="476.34"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.46"
					y1="663.41"
					x2="484.65"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.76"
					y1="663.41"
					x2="492.95"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.07"
					y1="663.41"
					x2="501.26"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.37"
					y1="663.41"
					x2="509.57"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.68"
					y1="663.41"
					x2="517.87"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.99"
					y1="663.41"
					x2="526.18"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.29"
					y1="663.41"
					x2="534.49"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.6"
					y1="663.41"
					x2="542.8"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.91"
					y1="663.41"
					x2="551.1"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.22"
					y1="663.41"
					x2="559.41"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.52"
					y1="663.41"
					x2="567.71"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.83"
					y1="663.41"
					x2="576.02"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.14"
					y1="663.41"
					x2="584.33"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.44"
					y1="663.41"
					x2="592.63"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.75"
					y1="663.41"
					x2="600.94"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.06"
					y1="663.41"
					x2="609.25"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.36"
					y1="663.41"
					x2="616.88"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="663.41"
					x2="616.88"
					y2="658.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="655.02"
					x2="616.88"
					y2="649.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="646.71"
					x2="616.88"
					y2="641.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="638.41"
					x2="616.88"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.88"
					y1="633.13"
					x2="612.36"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.25"
					y1="633.13"
					x2="604.06"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="633.13"
					x2="595.75"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.63"
					y1="633.13"
					x2="587.44"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.33"
					y1="633.13"
					x2="579.14"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.02"
					y1="633.13"
					x2="570.83"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.71"
					y1="633.13"
					x2="562.52"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.41"
					y1="633.13"
					x2="554.22"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.1"
					y1="633.13"
					x2="545.91"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.8"
					y1="633.13"
					x2="537.6"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.49"
					y1="633.13"
					x2="529.29"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.18"
					y1="633.13"
					x2="520.99"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.87"
					y1="633.13"
					x2="512.68"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.57"
					y1="633.13"
					x2="504.37"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.26"
					y1="633.13"
					x2="496.07"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.95"
					y1="633.13"
					x2="487.76"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.65"
					y1="633.13"
					x2="479.46"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.34"
					y1="633.13"
					x2="471.15"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.03"
					y1="633.13"
					x2="462.84"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.73"
					y1="633.13"
					x2="455.21"
					y2="633.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="633.13"
					x2="455.21"
					y2="638.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="641.52"
					x2="455.21"
					y2="646.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="649.83"
					x2="455.21"
					y2="655.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="658.14"
					x2="455.21"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="438.84 599.31 438.84 652.75 385.39 652.75 385.39 599.31 438.84 599.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="634.96 98.47 634.96 100.63 519.47 100.64 519.47 98.47 634.96 98.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="634.96"
					y1="98.47"
					x2="634.96"
					y2="100.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.96"
					y1="100.63"
					x2="519.47"
					y2="100.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.47"
					y1="100.64"
					x2="519.47"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.47"
					y1="98.47"
					x2="634.96"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="676.73 97.62 642.66 97.62 642.66 102.3 676.73 102.3 676.73 97.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="640.96 97.19 678.43 97.19 678.43 97.62 640.96 97.62 640.96 97.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="640.96"
					y1="97.19"
					x2="678.43"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.43"
					y1="97.19"
					x2="678.43"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.43"
					y1="97.62"
					x2="640.96"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.96"
					y1="97.62"
					x2="640.96"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.73"
					y1="102.3"
					x2="642.66"
					y2="102.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.66"
					y1="97.62"
					x2="676.73"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="680.56 102.3 676.73 102.3 676.73 97.62 680.56 97.62 680.56 102.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="680.56"
					y1="102.3"
					x2="676.73"
					y2="102.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.73"
					y1="102.3"
					x2="676.73"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.73"
					y1="97.62"
					x2="680.56"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.56"
					y1="97.62"
					x2="680.56"
					y2="102.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="638.83 97.62 642.66 97.62 642.66 102.3 638.83 102.3 638.83 97.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="638.83"
					y1="97.62"
					x2="642.66"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.66"
					y1="97.62"
					x2="642.66"
					y2="102.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.66"
					y1="102.3"
					x2="638.83"
					y2="102.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.83"
					y1="102.3"
					x2="638.83"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.73"
					y1="98.47"
					x2="642.66"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="682.26 101.88 680.56 101.88 680.56 97.62 678.43 97.62 678.43 97.19 682.26 97.19 682.26 101.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="682.26"
					y1="101.88"
					x2="680.56"
					y2="101.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.56"
					y1="101.88"
					x2="680.56"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.56"
					y1="97.62"
					x2="678.43"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.43"
					y1="97.62"
					x2="678.43"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.43"
					y1="97.19"
					x2="682.26"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.26"
					y1="97.19"
					x2="682.26"
					y2="101.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="637.12 97.19 640.96 97.19 640.96 97.62 638.83 97.62 638.83 101.88 637.12 101.88 637.12 97.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="637.12"
					y1="97.19"
					x2="640.96"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.96"
					y1="97.19"
					x2="640.96"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.96"
					y1="97.62"
					x2="638.83"
					y2="97.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.83"
					y1="97.62"
					x2="638.83"
					y2="101.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.83"
					y1="101.88"
					x2="637.12"
					y2="101.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.12"
					y1="101.88"
					x2="637.12"
					y2="97.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="632.8 98.47 637.12 98.47 637.12 111.45 632.8 111.45 632.8 98.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="637.12"
					y1="98.47"
					x2="632.8"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.12"
					y1="111.45"
					x2="637.12"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.8"
					y1="111.45"
					x2="637.12"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.8"
					y1="98.47"
					x2="632.8"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="686.59 98.47 686.59 111.45 682.26 111.45 682.26 98.47 686.59 98.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="686.59"
					y1="111.45"
					x2="686.59"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.26"
					y1="111.45"
					x2="686.59"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.26"
					y1="98.47"
					x2="682.26"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.59"
					y1="98.47"
					x2="682.26"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="517.31 98.47 521.63 98.47 521.63 111.45 517.31 111.45 517.31 98.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="521.63"
					y1="98.47"
					x2="517.31"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.63"
					y1="111.45"
					x2="521.63"
					y2="98.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.31"
					y1="111.45"
					x2="521.63"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.31"
					y1="98.47"
					x2="517.31"
					y2="111.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="322.52 54.33 322.52 56.49 234.1 56.49 234.1 54.33 322.52 54.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.52"
					y1="54.33"
					x2="322.52"
					y2="56.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.52"
					y1="56.49"
					x2="234.1"
					y2="56.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.1"
					y1="56.49"
					x2="234.1"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.1"
					y1="54.33"
					x2="322.52"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="366.3 53.47 330.22 53.47 330.22 58.16 366.3 58.16 366.3 53.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="328.52 53.05 368 53.05 368 53.47 328.52 53.47 328.52 53.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="328.52"
					y1="53.05"
					x2="368"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368"
					y1="53.05"
					x2="368"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368"
					y1="53.47"
					x2="328.52"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.52"
					y1="53.47"
					x2="328.52"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.3"
					y1="58.16"
					x2="330.22"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.22"
					y1="53.47"
					x2="366.3"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="370.13 58.16 366.3 58.16 366.3 53.47 370.13 53.47 370.13 58.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="370.13"
					y1="58.16"
					x2="366.3"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.3"
					y1="58.16"
					x2="366.3"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.3"
					y1="53.47"
					x2="370.13"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.13"
					y1="53.47"
					x2="370.13"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="326.39 53.47 330.22 53.47 330.22 58.16 326.39 58.16 326.39 53.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="326.39"
					y1="53.47"
					x2="330.22"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.22"
					y1="53.47"
					x2="330.22"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.22"
					y1="58.16"
					x2="326.39"
					y2="58.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.39"
					y1="58.16"
					x2="326.39"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.3"
					y1="54.33"
					x2="330.22"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="371.83 57.73 370.13 57.73 370.13 53.47 368 53.47 368 53.05 371.83 53.05 371.83 57.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="371.83"
					y1="57.73"
					x2="370.13"
					y2="57.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.13"
					y1="57.73"
					x2="370.13"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.13"
					y1="53.47"
					x2="368"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368"
					y1="53.47"
					x2="368"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368"
					y1="53.05"
					x2="371.83"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.83"
					y1="53.05"
					x2="371.83"
					y2="57.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="324.68 53.05 328.52 53.05 328.52 53.47 326.39 53.47 326.39 57.73 324.68 57.73 324.68 53.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="324.68"
					y1="53.05"
					x2="328.52"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.52"
					y1="53.05"
					x2="328.52"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.52"
					y1="53.47"
					x2="326.39"
					y2="53.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.39"
					y1="53.47"
					x2="326.39"
					y2="57.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.39"
					y1="57.73"
					x2="324.68"
					y2="57.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.68"
					y1="57.73"
					x2="324.68"
					y2="53.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="320.36 54.33 324.68 54.33 324.68 67.31 320.36 67.31 320.36 54.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="324.68"
					y1="54.33"
					x2="320.36"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.68"
					y1="67.31"
					x2="324.68"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.36"
					y1="67.31"
					x2="324.68"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.36"
					y1="54.33"
					x2="320.36"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="376.16 54.33 376.16 67.31 371.83 67.31 371.83 54.33 376.16 54.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="376.16"
					y1="67.31"
					x2="376.16"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.83"
					y1="67.31"
					x2="376.16"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.83"
					y1="54.33"
					x2="371.83"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.16"
					y1="54.33"
					x2="371.83"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="231.93 54.33 236.26 54.33 236.26 67.31 231.93 67.31 231.93 54.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="236.26"
					y1="54.33"
					x2="231.93"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.26"
					y1="67.31"
					x2="236.26"
					y2="54.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.93"
					y1="67.31"
					x2="236.26"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.93"
					y1="54.33"
					x2="231.93"
					y2="67.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.41"
					y1="791.53"
					x2="817.72"
					y2="791.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="844.68"
					y1="791.53"
					x2="817.72"
					y2="791.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="844.68"
					y1="719.98"
					x2="844.68"
					y2="791.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="824.74"
					y1="447.91"
					x2="824.74"
					y2="694.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="773.21"
					y1="447.91"
					x2="824.74"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="198.45"
					y1="447.91"
					x2="184.99"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="213.8"
					y1="590.52"
					x2="213.8"
					y2="607.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="213.8"
					y1="663.41"
					x2="213.8"
					y2="607.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="616.88"
					y1="663.41"
					x2="455.21"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="663.41"
					x2="213.8"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="948.92"
					x2="798.2"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="798.2"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="794.95"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="948.92"
					x2="713.83"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="713.83"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="717.08"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="948.92"
					x2="800.41"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="800.41"
					y1="931.61"
					x2="794.95"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="718.16 950 718.16 948.92 713.83 948.92 713.83 950 718.16 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="793.87 948.92 793.87 950 798.2 950 798.2 948.92 793.87 948.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="718.16 931.61 718.16 930.53 713.83 930.53 713.83 931.61 718.16 931.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="793.87 930.53 793.87 931.61 798.2 931.61 798.2 930.53 793.87 930.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="718.16"
					y1="950"
					x2="713.83"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.83"
					y1="950"
					x2="713.83"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.83"
					y1="948.92"
					x2="718.16"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.16"
					y1="948.92"
					x2="718.16"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.87"
					y1="948.92"
					x2="798.2"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.2"
					y1="948.92"
					x2="798.2"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.2"
					y1="950"
					x2="793.87"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.87"
					y1="950"
					x2="793.87"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.16"
					y1="931.61"
					x2="713.83"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.83"
					y1="931.61"
					x2="713.83"
					y2="930.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.83"
					y1="930.53"
					x2="718.16"
					y2="930.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.16"
					y1="930.53"
					x2="718.16"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.87"
					y1="930.53"
					x2="798.2"
					y2="930.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.2"
					y1="930.53"
					x2="798.2"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.2"
					y1="931.61"
					x2="793.87"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.87"
					y1="931.61"
					x2="793.87"
					y2="930.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="719.24 948.92 719.24 931.61 717.62 931.61 717.62 948.92 719.24 948.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="794.41 948.92 794.41 931.61 792.79 931.61 792.79 948.92 794.41 948.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="740.78 879.61 738.1 882.28 790.11 934.29 792.79 931.61 740.78 879.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="717.62"
					y1="931.61"
					x2="717.08"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.62"
					y1="948.92"
					x2="717.08"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="717.08"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.41"
					y1="931.61"
					x2="794.95"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.41"
					y1="948.92"
					x2="794.95"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="794.95"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.24"
					y1="948.92"
					x2="719.24"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.24"
					y1="931.61"
					x2="717.62"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.62"
					y1="931.61"
					x2="717.62"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.62"
					y1="948.92"
					x2="719.24"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.41"
					y1="948.92"
					x2="794.41"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.41"
					y1="931.61"
					x2="792.79"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.79"
					y1="931.61"
					x2="792.79"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.79"
					y1="948.92"
					x2="794.41"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.78"
					y1="879.61"
					x2="738.1"
					y2="882.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.1"
					y1="882.28"
					x2="790.11"
					y2="934.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.11"
					y1="934.29"
					x2="792.79"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.79"
					y1="931.61"
					x2="740.78"
					y2="879.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="717.08"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="717.08"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="713.83"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="931.61"
					x2="713.83"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="948.92"
					x2="713.83"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="717.08"
					y1="948.92"
					x2="713.83"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="794.95"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="794.95"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="798.2"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="931.61"
					x2="798.2"
					y2="931.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="948.92"
					x2="798.2"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.95"
					y1="948.92"
					x2="798.2"
					y2="948.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="458.73"
					x2="452.77"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="452.77"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="449.52"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="458.73"
					x2="368.4"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="368.4"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="371.65"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="324.49"
					y1="447.91"
					x2="198.45"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="372.73 459.81 372.73 458.73 368.4 458.73 368.4 459.81 372.73 459.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.44 458.73 448.44 459.81 452.77 459.81 452.77 458.73 448.44 458.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="372.73 447.91 372.73 446.83 368.4 446.83 368.4 447.91 372.73 447.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.44 446.83 448.44 447.91 452.77 447.91 452.77 446.83 448.44 446.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="372.73"
					y1="459.81"
					x2="368.4"
					y2="459.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.4"
					y1="459.81"
					x2="368.4"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.4"
					y1="458.73"
					x2="372.73"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.73"
					y1="458.73"
					x2="372.73"
					y2="459.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.44"
					y1="458.73"
					x2="452.77"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.77"
					y1="458.73"
					x2="452.77"
					y2="459.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.77"
					y1="459.81"
					x2="448.44"
					y2="459.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.44"
					y1="459.81"
					x2="448.44"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.73"
					y1="447.91"
					x2="368.4"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.4"
					y1="447.91"
					x2="368.4"
					y2="446.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.4"
					y1="446.83"
					x2="372.73"
					y2="446.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.73"
					y1="446.83"
					x2="372.73"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.44"
					y1="446.83"
					x2="452.77"
					y2="446.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.77"
					y1="446.83"
					x2="452.77"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.77"
					y1="447.91"
					x2="448.44"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.44"
					y1="447.91"
					x2="448.44"
					y2="446.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.81 458.73 373.81 447.91 372.19 447.91 372.19 458.73 373.81 458.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.98 458.73 448.98 447.91 447.36 447.91 447.36 458.73 448.98 458.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="395.35 395.9 392.68 398.58 444.68 450.59 447.36 447.91 395.35 395.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="372.19"
					y1="447.91"
					x2="371.65"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.19"
					y1="458.73"
					x2="371.65"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="371.65"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.98"
					y1="447.91"
					x2="449.52"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.98"
					y1="458.73"
					x2="449.52"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="449.52"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.81"
					y1="458.73"
					x2="373.81"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.81"
					y1="447.91"
					x2="372.19"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.19"
					y1="447.91"
					x2="372.19"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.19"
					y1="458.73"
					x2="373.81"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.98"
					y1="458.73"
					x2="448.98"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.98"
					y1="447.91"
					x2="447.36"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.36"
					y1="447.91"
					x2="447.36"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.36"
					y1="458.73"
					x2="448.98"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.35"
					y1="395.9"
					x2="392.68"
					y2="398.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.68"
					y1="398.58"
					x2="444.68"
					y2="450.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.68"
					y1="450.59"
					x2="447.36"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.36"
					y1="447.91"
					x2="395.35"
					y2="395.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="371.65"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="371.65"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="368.4"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="447.91"
					x2="368.4"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="458.73"
					x2="368.4"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="371.65"
					y1="458.73"
					x2="368.4"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="449.52"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="449.52"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="452.77"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="447.91"
					x2="452.77"
					y2="447.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="458.73"
					x2="452.77"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="449.52"
					y1="458.73"
					x2="452.77"
					y2="458.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="391.14"
					x2="190.95"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="188.25"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="190.95"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="393.3"
					x2="320.21"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="391.14"
					x2="317.5"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="320.21"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="317.5"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="315.88 391.14 315.88 393.3 316.96 393.3 316.96 391.14 315.88 391.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="315.88 394.38 320.21 394.38 320.21 393.3 315.88 393.3 315.88 394.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="191.49 391.14 191.49 393.3 192.58 393.3 192.58 391.14 191.49 391.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="315.88 382.49 320.21 382.49 320.21 379.78 315.88 379.78 315.88 382.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="192.58 379.78 188.25 379.78 188.25 382.49 192.58 382.49 192.58 379.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="315.88"
					y1="391.14"
					x2="315.88"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.88"
					y1="393.3"
					x2="316.96"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="393.3"
					x2="316.96"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="391.14"
					x2="315.88"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.88"
					y1="394.38"
					x2="320.21"
					y2="394.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.21"
					y1="394.38"
					x2="320.21"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.21"
					y1="393.3"
					x2="315.88"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.88"
					y1="393.3"
					x2="315.88"
					y2="394.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="391.14"
					x2="191.49"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="393.3"
					x2="192.58"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.58"
					y1="393.3"
					x2="192.58"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.58"
					y1="391.14"
					x2="191.49"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.58"
					y1="394.38"
					x2="192.58"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.88"
					y1="382.49"
					x2="320.21"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.21"
					y1="382.49"
					x2="320.21"
					y2="379.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.21"
					y1="379.78"
					x2="315.88"
					y2="379.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.88"
					y1="379.78"
					x2="315.88"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.58"
					y1="379.78"
					x2="188.25"
					y2="379.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.25"
					y1="379.78"
					x2="188.25"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.25"
					y1="382.49"
					x2="192.58"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.58"
					y1="382.49"
					x2="192.58"
					y2="379.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="312.63 391.14 316.96 391.14 316.96 382.49 312.63 382.49 312.63 391.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="191.49 391.14 195.82 391.14 195.82 382.49 191.49 382.49 191.49 391.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="256.39 382.49 195.82 382.49 195.82 386.27 256.39 386.27 256.39 382.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="286.68 386.27 226.11 386.27 226.11 390.06 286.68 390.06 286.68 386.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.96"
					y1="382.49"
					x2="317.5"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="391.14"
					x2="317.5"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="317.5"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="382.49"
					x2="190.95"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="391.14"
					x2="190.95"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="190.95"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.63"
					y1="391.14"
					x2="312.63"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.63"
					y1="382.49"
					x2="316.96"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="382.49"
					x2="316.96"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.96"
					y1="391.14"
					x2="312.63"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="391.14"
					x2="191.49"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.49"
					y1="382.49"
					x2="195.82"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.82"
					y1="382.49"
					x2="195.82"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.82"
					y1="391.14"
					x2="191.49"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.39"
					y1="382.49"
					x2="256.39"
					y2="386.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.39"
					y1="386.27"
					x2="195.82"
					y2="386.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.82"
					y1="386.27"
					x2="195.82"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.82"
					y1="382.49"
					x2="256.39"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.68"
					y1="386.27"
					x2="286.68"
					y2="390.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.68"
					y1="390.06"
					x2="226.11"
					y2="390.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.11"
					y1="390.06"
					x2="226.11"
					y2="386.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.11"
					y1="386.27"
					x2="286.68"
					y2="386.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="317.5"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="317.5"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="391.14"
					x2="317.5"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="382.49"
					x2="320.21"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="391.14"
					x2="317.5"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="393.3"
					x2="320.21"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="317.5"
					y1="393.3"
					x2="320.21"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="190.95"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="190.95"
					y2="391.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="391.14"
					x2="190.95"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="382.49"
					x2="188.25"
					y2="382.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="190.95"
					y1="391.14"
					x2="190.95"
					y2="393.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="467.14"
					x2="356.13"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="345.32"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="356.13"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="545.02"
					x2="356.13"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="345.32"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="356.13"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="357.21 543.94 356.13 543.94 356.13 548.26 357.21 548.26 357.21 543.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="356.13 468.22 357.21 468.22 357.21 463.9 356.13 463.9 356.13 468.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="345.32 543.94 344.24 543.94 344.24 548.26 345.32 548.26 345.32 543.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="344.24 468.22 345.32 468.22 345.32 463.9 344.24 463.9 344.24 468.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="357.21"
					y1="543.94"
					x2="357.21"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.21"
					y1="548.26"
					x2="356.13"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="548.26"
					x2="356.13"
					y2="543.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="543.94"
					x2="357.21"
					y2="543.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="468.22"
					x2="356.13"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="463.9"
					x2="357.21"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.21"
					y1="463.9"
					x2="357.21"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.21"
					y1="468.22"
					x2="356.13"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="543.94"
					x2="345.32"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="548.26"
					x2="344.24"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.24"
					y1="548.26"
					x2="344.24"
					y2="543.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.24"
					y1="543.94"
					x2="345.32"
					y2="543.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.24"
					y1="468.22"
					x2="344.24"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.24"
					y1="463.9"
					x2="345.32"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="463.9"
					x2="345.32"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="468.22"
					x2="344.24"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="356.13 542.86 345.32 542.86 345.32 544.48 356.13 544.48 356.13 542.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="356.13 467.68 345.32 467.68 345.32 469.31 356.13 469.31 356.13 467.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="293.31 521.31 295.99 523.99 347.99 471.98 345.32 469.31 293.31 521.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="345.32"
					y1="544.48"
					x2="345.32"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="544.48"
					x2="356.13"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="356.13"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="467.68"
					x2="345.32"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="467.68"
					x2="356.13"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="356.13"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="542.86"
					x2="345.32"
					y2="542.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="542.86"
					x2="345.32"
					y2="544.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="544.48"
					x2="356.13"
					y2="544.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="544.48"
					x2="356.13"
					y2="542.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="467.68"
					x2="345.32"
					y2="467.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="467.68"
					x2="345.32"
					y2="469.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="469.31"
					x2="356.13"
					y2="469.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.13"
					y1="469.31"
					x2="356.13"
					y2="467.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.31"
					y1="521.31"
					x2="295.99"
					y2="523.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.99"
					y1="523.99"
					x2="347.99"
					y2="471.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.99"
					y1="471.98"
					x2="345.32"
					y2="469.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="469.31"
					x2="293.31"
					y2="521.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="356.13"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="356.13"
					y2="545.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="345.32"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="545.02"
					x2="345.32"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="545.02"
					x2="356.13"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="545.02"
					x2="356.13"
					y2="548.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="356.13"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="356.13"
					y2="467.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="345.32"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="345.32"
					y1="467.14"
					x2="345.32"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="467.14"
					x2="356.13"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="356.13"
					y1="467.14"
					x2="356.13"
					y2="463.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="595.5"
					x2="380.33"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="380.33"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="595.5"
					x2="443.07"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="443.07"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="439.82"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="378.89"
					y1="595.5"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="595.5"
					x2="444.4"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="438.74 596.58 443.07 596.58 443.07 595.5 438.74 595.5 438.74 596.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="384.66 595.5 380.33 595.5 380.33 596.58 384.66 596.58 384.66 595.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="438.74 584.68 443.07 584.68 443.07 583.6 438.74 583.6 438.74 584.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="384.66 583.6 380.33 583.6 380.33 584.68 384.66 584.68 384.66 583.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="438.74"
					y1="596.58"
					x2="443.07"
					y2="596.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.07"
					y1="596.58"
					x2="443.07"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.07"
					y1="595.5"
					x2="438.74"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.74"
					y1="595.5"
					x2="438.74"
					y2="596.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="595.5"
					x2="380.33"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.33"
					y1="595.5"
					x2="380.33"
					y2="596.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.33"
					y1="596.58"
					x2="384.66"
					y2="596.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="596.58"
					x2="384.66"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.74"
					y1="584.68"
					x2="443.07"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.07"
					y1="584.68"
					x2="443.07"
					y2="583.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.07"
					y1="583.6"
					x2="438.74"
					y2="583.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.74"
					y1="583.6"
					x2="438.74"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="583.6"
					x2="380.33"
					y2="583.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.33"
					y1="583.6"
					x2="380.33"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.33"
					y1="584.68"
					x2="384.66"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.66"
					y1="584.68"
					x2="384.66"
					y2="583.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="437.66 595.5 439.28 595.5 439.28 584.68 437.66 584.68 437.66 595.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="384.12 595.5 385.74 595.5 385.74 584.68 384.12 584.68 384.12 595.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="422.45 547.97 385.74 584.68 388.42 587.36 425.13 550.65 422.45 547.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="439.28"
					y1="584.68"
					x2="439.82"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.28"
					y1="595.5"
					x2="439.82"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="439.82"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.12"
					y1="584.68"
					x2="383.58"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.12"
					y1="595.5"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.66"
					y1="595.5"
					x2="437.66"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.66"
					y1="584.68"
					x2="439.28"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.28"
					y1="584.68"
					x2="439.28"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.28"
					y1="595.5"
					x2="437.66"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.12"
					y1="595.5"
					x2="384.12"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.12"
					y1="584.68"
					x2="385.74"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.74"
					y1="584.68"
					x2="385.74"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.74"
					y1="595.5"
					x2="384.12"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.45"
					y1="547.97"
					x2="425.13"
					y2="550.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.13"
					y1="550.65"
					x2="388.42"
					y2="587.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.42"
					y1="587.36"
					x2="385.74"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.74"
					y1="584.68"
					x2="422.45"
					y2="547.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="439.82"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="439.82"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="443.07"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="584.68"
					x2="443.07"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="595.5"
					x2="443.07"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="439.82"
					y1="595.5"
					x2="443.07"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="383.58"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="380.33"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="584.68"
					x2="380.33"
					y2="584.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="595.5"
					x2="380.33"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="383.58"
					y1="595.5"
					x2="380.33"
					y2="595.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="608.82"
					x2="601.12"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="606.66"
					x2="598.42"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="598"
					x2="601.12"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="598"
					x2="598.42"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="608.82"
					x2="469.17"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="606.66"
					x2="471.87"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="598"
					x2="469.17"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="598"
					x2="471.87"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="473.5 606.66 472.41 606.66 472.41 608.82 473.5 608.82 473.5 606.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="473.5 609.9 473.5 608.82 469.17 608.82 469.17 609.9 473.5 609.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.88 606.66 596.8 606.66 596.8 608.82 597.88 608.82 597.88 606.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.8 608.82 596.8 609.9 601.12 609.9 601.12 608.82 596.8 608.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="473.5 598 473.5 595.3 469.17 595.3 469.17 598 473.5 598"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.8 595.3 596.8 598 601.12 598 601.12 595.3 596.8 595.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="473.5"
					y1="606.66"
					x2="473.5"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.5"
					y1="608.82"
					x2="472.41"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="608.82"
					x2="472.41"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="606.66"
					x2="473.5"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.5"
					y1="609.9"
					x2="469.17"
					y2="609.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.17"
					y1="609.9"
					x2="469.17"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.17"
					y1="608.82"
					x2="473.5"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.5"
					y1="608.82"
					x2="473.5"
					y2="609.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="606.66"
					x2="597.88"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="608.82"
					x2="596.8"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="608.82"
					x2="596.8"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="606.66"
					x2="597.88"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="608.82"
					x2="601.12"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.12"
					y1="608.82"
					x2="601.12"
					y2="609.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.12"
					y1="609.9"
					x2="596.8"
					y2="609.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="609.9"
					x2="596.8"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.5"
					y1="598"
					x2="469.17"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.17"
					y1="598"
					x2="469.17"
					y2="595.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.17"
					y1="595.3"
					x2="473.5"
					y2="595.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.5"
					y1="595.3"
					x2="473.5"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="595.3"
					x2="601.12"
					y2="595.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.12"
					y1="595.3"
					x2="601.12"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.12"
					y1="598"
					x2="596.8"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.8"
					y1="598"
					x2="596.8"
					y2="595.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="476.74 598 472.41 598 472.41 606.66 476.74 606.66 476.74 598"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.88 598 593.55 598 593.55 606.66 597.88 606.66 597.88 598"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="532.98 606.66 593.55 606.66 593.55 602.87 532.98 602.87 532.98 606.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="502.7 602.87 563.27 602.87 563.27 599.08 502.7 599.08 502.7 602.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="472.41"
					y1="606.66"
					x2="471.87"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="598"
					x2="471.87"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.87"
					y1="606.66"
					x2="471.87"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="606.66"
					x2="598.42"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="598"
					x2="598.42"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.42"
					y1="606.66"
					x2="598.42"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.74"
					y1="598"
					x2="476.74"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.74"
					y1="606.66"
					x2="472.41"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="606.66"
					x2="472.41"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.41"
					y1="598"
					x2="476.74"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="598"
					x2="597.88"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.88"
					y1="606.66"
					x2="593.55"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.55"
					y1="606.66"
					x2="593.55"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.55"
					y1="598"
					x2="597.88"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.98"
					y1="606.66"
					x2="532.98"
					y2="602.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.98"
					y1="602.87"
					x2="593.55"
					y2="602.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.55"
					y1="602.87"
					x2="593.55"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.55"
					y1="606.66"
					x2="532.98"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.7"
					y1="602.87"
					x2="502.7"
					y2="599.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.7"
					y1="599.08"
					x2="563.27"
					y2="599.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.27"
					y1="599.08"
					x2="563.27"
					y2="602.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.27"
					y1="602.87"
					x2="502.7"
					y2="602.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.87"
					y1="598"
					x2="471.87"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="598"
					x2="471.87"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="606.66"
					x2="471.87"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="598"
					x2="469.17"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="606.66"
					x2="471.87"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="608.82"
					x2="469.17"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="471.87"
					y1="608.82"
					x2="469.17"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="598"
					x2="598.42"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="598"
					x2="598.42"
					y2="606.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="606.66"
					x2="598.42"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="598"
					x2="601.12"
					y2="598"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="606.66"
					x2="598.42"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="608.82"
					x2="601.12"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.42"
					y1="608.82"
					x2="601.12"
					y2="608.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="824.74"
					y1="719.98"
					x2="844.68"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="824.74"
					y1="719.98"
					x2="824.74"
					y2="702.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="824.74"
					y1="694.01"
					x2="824.74"
					y2="702.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="255.26 502.52 256.99 498.66 257.59 494.48 256.99 490.29 255.26 486.43 253.08 483.89 250.34 481.96 243.9 479.51 238.55 478.64 233.14 478.97 227.94 480.46 223.18 480.34 218.57 479.13 214.36 476.91 212.53 475.75 208.78 474.37 204.78 474.58 203.2 475.2 199 475.2 199 476.95 200.92 476.95 199.14 479.88 198.45 483.24 198.45 505.71 199.13 509.03 200.97 511.88 203.71 513.86 206.99 514.72 207.51 514.72 210.21 514.27 214.46 511.99 218.62 509.78 223.18 508.59 227.89 508.47 233.11 509.98 238.53 510.31 243.9 509.44 250.34 506.99 253.08 505.06 255.26 502.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="218.43"
					y1="486.47"
					x2="218.43"
					y2="502.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="505.71"
					x2="198.45"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.26"
					y1="505.71"
					x2="199.26"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="483.24"
					x2="198.45"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.26"
					y1="483.24"
					x2="199.26"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.43"
					y1="502.07"
					x2="215.44"
					y2="502.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="502.07"
					x2="215.44"
					y2="499.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="499.59"
					x2="218.43"
					y2="499.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.43"
					y1="486.88"
					x2="215.44"
					y2="486.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="486.88"
					x2="215.44"
					y2="489.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.44"
					y1="489.36"
					x2="218.43"
					y2="489.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.44"
					y1="476.95"
					x2="199"
					y2="476.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.44"
					y1="475.2"
					x2="199"
					y2="475.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199"
					y1="475.2"
					x2="199"
					y2="476.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.44"
					y1="475.2"
					x2="206.44"
					y2="476.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.59"
					y1="494.48"
					x2="257.28"
					y2="497.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.28"
					y1="497.16"
					x2="256.58"
					y2="499.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.58"
					y1="499.76"
					x2="255.26"
					y2="502.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.26"
					y1="502.52"
					x2="253.08"
					y2="505.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.08"
					y1="505.07"
					x2="250.34"
					y2="506.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.34"
					y1="506.99"
					x2="247.21"
					y2="508.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.21"
					y1="508.42"
					x2="243.9"
					y2="509.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.9"
					y1="509.44"
					x2="238.54"
					y2="510.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.54"
					y1="510.38"
					x2="235.84"
					y2="510.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.84"
					y1="510.43"
					x2="233.15"
					y2="510.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.15"
					y1="510.13"
					x2="228.97"
					y2="508.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.97"
					y1="508.91"
					x2="224.93"
					y2="507.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.93"
					y1="507.02"
					x2="221.32"
					y2="504.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.32"
					y1="504.77"
					x2="218.43"
					y2="502.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.89"
					y1="508.47"
					x2="224.14"
					y2="508.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.14"
					y1="508.49"
					x2="220.49"
					y2="509.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.49"
					y1="509.11"
					x2="216.58"
					y2="510.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.58"
					y1="510.66"
					x2="213.74"
					y2="512.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="512.47"
					x2="210.81"
					y2="514.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.81"
					y1="514.06"
					x2="207.95"
					y2="514.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.95"
					y1="514.7"
					x2="205.09"
					y2="514.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.09"
					y1="514.45"
					x2="202.5"
					y2="513.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.5"
					y1="513.34"
					x2="200.41"
					y2="511.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.41"
					y1="511.38"
					x2="199.35"
					y2="509.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="509.46"
					x2="198.76"
					y2="507.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.76"
					y1="507.63"
					x2="198.45"
					y2="505.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.26"
					y1="505.71"
					x2="199.35"
					y2="506.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="506.57"
					x2="199.9"
					y2="508.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.9"
					y1="508.33"
					x2="201.21"
					y2="509.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.21"
					y1="509.9"
					x2="203.04"
					y2="510.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.04"
					y1="510.87"
					x2="205.45"
					y2="511.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.45"
					y1="511.34"
					x2="207.94"
					y2="511.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.94"
					y1="511.45"
					x2="209.18"
					y2="511.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.18"
					y1="511.43"
					x2="210.16"
					y2="510.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.16"
					y1="510.91"
					x2="210.44"
					y2="510.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.44"
					y1="510.3"
					x2="212.37"
					y2="503.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="503.5"
					x2="212.95"
					y2="500.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.95"
					y1="500.13"
					x2="213.19"
					y2="496.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="496.71"
					x2="213.19"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.94"
					y1="480.46"
					x2="224.18"
					y2="480.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.18"
					y1="480.43"
					x2="220.51"
					y2="479.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.51"
					y1="479.82"
					x2="216.58"
					y2="478.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.58"
					y1="478.29"
					x2="213.74"
					y2="476.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="476.5"
					x2="210.81"
					y2="474.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.81"
					y1="474.89"
					x2="208.9"
					y2="474.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.9"
					y1="474.37"
					x2="206.93"
					y2="474.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.93"
					y1="474.24"
					x2="205"
					y2="474.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205"
					y1="474.52"
					x2="203.2"
					y2="475.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.26"
					y1="483.24"
					x2="199.35"
					y2="482.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="482.38"
					x2="199.9"
					y2="480.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.9"
					y1="480.62"
					x2="201.21"
					y2="479.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.21"
					y1="479.05"
					x2="203.04"
					y2="478.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.04"
					y1="478.08"
					x2="205.45"
					y2="477.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.45"
					y1="477.61"
					x2="207.94"
					y2="477.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.94"
					y1="477.5"
					x2="209.18"
					y2="477.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.18"
					y1="477.52"
					x2="210.16"
					y2="478.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.16"
					y1="478.04"
					x2="210.44"
					y2="478.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.44"
					y1="478.65"
					x2="212.37"
					y2="485.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="485.45"
					x2="212.95"
					y2="488.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.95"
					y1="488.82"
					x2="213.19"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="492.24"
					x2="213.19"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.59"
					y1="494.48"
					x2="257.28"
					y2="491.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.28"
					y1="491.79"
					x2="256.58"
					y2="489.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.58"
					y1="489.19"
					x2="255.26"
					y2="486.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.26"
					y1="486.43"
					x2="253.08"
					y2="483.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.08"
					y1="483.88"
					x2="250.34"
					y2="481.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.34"
					y1="481.96"
					x2="247.21"
					y2="480.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.21"
					y1="480.54"
					x2="243.9"
					y2="479.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.9"
					y1="479.51"
					x2="238.54"
					y2="478.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.54"
					y1="478.57"
					x2="235.84"
					y2="478.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.84"
					y1="478.52"
					x2="233.15"
					y2="478.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.15"
					y1="478.82"
					x2="228.97"
					y2="480.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.97"
					y1="480.04"
					x2="224.93"
					y2="481.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.93"
					y1="481.93"
					x2="221.32"
					y2="484.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.32"
					y1="484.18"
					x2="218.43"
					y2="486.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="513.31"
					x2="212.98"
					y2="512.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.98"
					y1="512.88"
					x2="213.89"
					y2="511.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.89"
					y1="511.64"
					x2="214.11"
					y2="510.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.11"
					y1="510.57"
					x2="214.7"
					y2="503.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.7"
					y1="503.66"
					x2="214.96"
					y2="496.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.96"
					y1="496.74"
					x2="214.96"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="475.65"
					x2="212.98"
					y2="476.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.98"
					y1="476.07"
					x2="213.89"
					y2="477.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.89"
					y1="477.31"
					x2="214.11"
					y2="478.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.11"
					y1="478.39"
					x2="214.7"
					y2="485.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.7"
					y1="485.29"
					x2="214.96"
					y2="492.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.96"
					y1="492.21"
					x2="214.96"
					y2="494.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.92"
					y1="476.95"
					x2="200.41"
					y2="477.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.41"
					y1="477.57"
					x2="199.35"
					y2="479.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="479.49"
					x2="198.76"
					y2="481.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.76"
					y1="481.32"
					x2="198.45"
					y2="483.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="198.45 520.43 199.32 520.43 199.32 516.11 198.45 516.11 198.45 520.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="198.45"
					y1="516.11"
					x2="198.45"
					y2="520.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="516.11"
					x2="198.45"
					y2="516.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="520.43"
					x2="199.32"
					y2="516.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="520.43"
					x2="199.32"
					y2="520.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="198.45 468.52 198.45 472.84 199.32 472.84 199.32 468.52 198.45 468.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="199.32"
					y1="468.52"
					x2="198.45"
					y2="468.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="472.84"
					x2="199.32"
					y2="468.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="472.84"
					x2="199.32"
					y2="472.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="468.52"
					x2="198.45"
					y2="472.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="199.32 518.71 206.36 518.71 206.36 517.84 199.32 517.84 199.32 518.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="199.32"
					y1="517.84"
					x2="199.32"
					y2="518.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.36"
					y1="517.84"
					x2="199.32"
					y2="517.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.36"
					y1="518.71"
					x2="206.36"
					y2="517.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="518.71"
					x2="206.36"
					y2="518.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="199.32 470.25 199.32 471.11 206.36 471.11 206.36 470.25 199.32 470.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="206.36"
					y1="470.25"
					x2="199.32"
					y2="470.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.36"
					y1="471.11"
					x2="206.36"
					y2="470.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="471.11"
					x2="206.36"
					y2="471.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.32"
					y1="470.25"
					x2="199.32"
					y2="471.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="204.2 517.84 205.93 517.84 205.93 471.11 204.2 471.11 204.2 517.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.2"
					y1="471.11"
					x2="204.2"
					y2="517.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.93"
					y1="471.11"
					x2="204.2"
					y2="471.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.93"
					y1="517.84"
					x2="205.93"
					y2="471.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.2"
					y1="517.84"
					x2="205.93"
					y2="517.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="345.32 663.41 345.32 592.58 213.8 592.58 213.8 663.41 345.32 663.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.8"
					y1="663.41"
					x2="345.32"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.8"
					y1="592.58"
					x2="213.8"
					y2="663.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="592.58"
					x2="213.8"
					y2="592.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.32"
					y1="663.41"
					x2="345.32"
					y2="592.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.06"
					y1="659.16"
					x2="341.06"
					y2="659.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.06"
					y1="659.16"
					x2="341.06"
					y2="596.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.06"
					y1="596.84"
					x2="218.06"
					y2="596.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.06"
					y1="596.84"
					x2="218.06"
					y2="659.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.06"
					y1="659.16"
					x2="273.39"
					y2="630.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.06"
					y1="596.84"
					x2="273.39"
					y2="625.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.06"
					y1="659.16"
					x2="285.72"
					y2="630.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.06"
					y1="596.84"
					x2="285.72"
					y2="625.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.56"
					y1="632.26"
					x2="279.56"
					y2="623.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.82"
					y1="628"
					x2="275.3"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="213.8 628 222.83 634.65 222.83 621.35 213.8 628"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="222.83"
					y1="621.35"
					x2="213.8"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.83"
					y1="634.65"
					x2="222.83"
					y2="621.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.8"
					y1="628"
					x2="222.83"
					y2="634.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.9"
					y1="628"
					x2="230.45"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.83"
					y1="628"
					x2="222.83"
					y2="621.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.83"
					y1="621.35"
					x2="213.8"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.83"
					y1="628"
					x2="222.83"
					y2="634.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.83"
					y1="634.65"
					x2="213.8"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.72"
					y1="626.04"
					x2="229.54"
					y2="623.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.72"
					y1="629.96"
					x2="229.54"
					y2="632.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="775.38 565.04 824.74 565.04 824.74 516.53 775.38 516.53 775.38 565.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.38"
					y1="516.53"
					x2="775.38"
					y2="518.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="521.57"
					x2="775.38"
					y2="526.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="529.88"
					x2="775.38"
					y2="535.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="538.18"
					x2="775.38"
					y2="543.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="546.49"
					x2="775.38"
					y2="551.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="554.8"
					x2="775.38"
					y2="559.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="563.1"
					x2="775.38"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="516.53"
					x2="822.38"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.27"
					y1="516.53"
					x2="814.08"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.96"
					y1="516.53"
					x2="805.77"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.66"
					y1="516.53"
					x2="797.46"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.35"
					y1="516.53"
					x2="789.16"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.04"
					y1="516.53"
					x2="780.85"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.74"
					y1="516.53"
					x2="775.38"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="565.03"
					x2="824.74"
					y2="563.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="559.99"
					x2="824.74"
					y2="554.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="551.68"
					x2="824.74"
					y2="546.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="543.38"
					x2="824.74"
					y2="538.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="535.07"
					x2="824.74"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="526.76"
					x2="824.74"
					y2="521.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="518.45"
					x2="824.74"
					y2="516.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="565.03"
					x2="777.74"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.85"
					y1="565.03"
					x2="786.04"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.16"
					y1="565.03"
					x2="794.35"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.46"
					y1="565.03"
					x2="802.66"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.77"
					y1="565.03"
					x2="810.96"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.08"
					y1="565.03"
					x2="819.27"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.38"
					y1="565.03"
					x2="824.74"
					y2="565.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.82 516.71 771.33 516.71 771.33 564.85 772.82 564.85 772.82 557.3 771.6 557.3 771.6 524.26 772.82 524.26 772.82 516.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.82"
					y1="524.26"
					x2="772.82"
					y2="516.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="771.6"
					y1="524.26"
					x2="772.82"
					y2="524.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="771.6"
					y1="557.3"
					x2="771.6"
					y2="524.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="557.3"
					x2="771.6"
					y2="557.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="564.85"
					x2="772.82"
					y2="557.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="771.33"
					y1="564.85"
					x2="772.82"
					y2="564.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="771.33"
					y1="516.71"
					x2="771.33"
					y2="564.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="516.71"
					x2="771.33"
					y2="516.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="772.82 514.82 772.82 566.74 775.38 566.74 775.38 514.82 772.82 514.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.38"
					y1="514.82"
					x2="772.82"
					y2="514.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="775.38"
					y1="566.74"
					x2="775.38"
					y2="514.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="566.74"
					x2="775.38"
					y2="566.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="514.82"
					x2="772.82"
					y2="566.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="772.82"
					y1="564.85"
					x2="771.33"
					y2="564.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.33"
					y1="564.85"
					x2="771.33"
					y2="516.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.33"
					y1="516.71"
					x2="772.82"
					y2="516.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="566.74"
					x2="772.82"
					y2="514.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="524.26"
					x2="771.6"
					y2="524.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.6"
					y1="524.26"
					x2="771.6"
					y2="557.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.6"
					y1="557.3"
					x2="772.82"
					y2="557.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="566.74"
					x2="772.82"
					y2="566.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="514.82"
					x2="775.38"
					y2="514.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.38"
					y1="514.82"
					x2="775.38"
					y2="566.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.39 791.53 765.39 719.98 844.68 719.98 844.68 791.53 765.39 791.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765.39"
					y1="791.53"
					x2="765.39"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.39"
					y1="719.98"
					x2="844.68"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.68"
					y1="719.98"
					x2="844.68"
					y2="791.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.68"
					y1="791.53"
					x2="765.39"
					y2="791.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.8"
					y1="791.53"
					x2="770.8"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="779.04 572.41 779.04 626.3 779.54 627.5 780.75 628 816.82 628 818.02 627.5 818.52 626.3 818.52 572.41 818.02 571.21 816.82 570.71 780.75 570.71 779.54 571.21 779.04 572.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="816.82"
					y1="570.71"
					x2="780.75"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.52"
					y1="626.3"
					x2="818.52"
					y2="572.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.75"
					y1="628"
					x2="816.82"
					y2="628"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.04"
					y1="572.41"
					x2="779.04"
					y2="626.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.3"
					y1="576.67"
					x2="783.3"
					y2="622.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.01"
					y1="623.74"
					x2="808.3"
					y2="623.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810"
					y1="622.04"
					x2="810"
					y2="576.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.3"
					y1="574.97"
					x2="785.01"
					y2="574.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.3"
					y1="576.67"
					x2="783.3"
					y2="576.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="799.11 598.59 798.57 598.81 798.35 599.36 798.58 599.9 799.12 600.12 815.97 600.12 816.51 599.9 816.73 599.35 816.51 598.81 815.97 598.59 799.11 598.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="815.97"
					y1="598.59"
					x2="799.11"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.12"
					y1="600.12"
					x2="815.97"
					y2="600.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="811.62 597.65 811.62 598.59 815.97 598.59 816.51 598.81 816.73 599.35 816.51 599.9 815.97 600.12 811.62 600.12 811.62 601.05 817.16 601.05 817.16 597.65 811.62 597.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="817.16"
					y1="597.65"
					x2="811.62"
					y2="597.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.16"
					y1="601.05"
					x2="817.16"
					y2="597.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.62"
					y1="601.05"
					x2="817.16"
					y2="601.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.62"
					y1="600.12"
					x2="811.62"
					y2="601.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.97"
					y1="600.12"
					x2="811.62"
					y2="600.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m815.97,598.59c.42,0,.76.34.76.76s-.34.77-.76.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.62"
					y1="598.59"
					x2="815.97"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.62"
					y1="597.65"
					x2="811.62"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="808.56 597.68 808.56 598.59 811.54 598.59 811.54 597.68 808.56 597.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="811.54"
					y1="597.68"
					x2="808.56"
					y2="597.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.54"
					y1="598.59"
					x2="811.54"
					y2="597.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.56"
					y1="598.59"
					x2="811.54"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.56"
					y1="597.68"
					x2="808.56"
					y2="598.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="808.56 601.03 811.54 601.03 811.54 600.12 808.56 600.12 808.56 601.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="808.56"
					y1="600.12"
					x2="808.56"
					y2="601.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.54"
					y1="600.12"
					x2="808.56"
					y2="600.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.54"
					y1="601.03"
					x2="811.54"
					y2="600.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.56"
					y1="601.03"
					x2="811.54"
					y2="601.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="241.7 587.76 241.7 531.52 198.45 531.52 198.45 587.76 241.7 587.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="241.7"
					y1="587.76"
					x2="241.7"
					y2="531.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.45"
					y1="587.76"
					x2="198.45"
					y2="531.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.7"
					y1="531.52"
					x2="198.45"
					y2="531.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.7"
					y1="587.76"
					x2="198.45"
					y2="587.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.16"
					y1="587.76"
					x2="200.16"
					y2="531.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.43"
					y1="581.27"
					x2="231.43"
					y2="538.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.43"
					y1="538.01"
					x2="205.48"
					y2="538.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.48"
					y1="538.01"
					x2="205.48"
					y2="581.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.48"
					y1="581.27"
					x2="231.43"
					y2="581.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.14"
					y1="582.97"
					x2="233.14"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.14"
					y1="536.3"
					x2="203.77"
					y2="536.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.77"
					y1="536.3"
					x2="203.77"
					y2="582.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.77"
					y1="582.97"
					x2="233.14"
					y2="582.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="200.79 561.77 204.36 561.43 205.17 561.15 209.68 560.59 210.28 560.27 210.52 559.64 210.28 559.01 209.68 558.69 205.17 558.13 204.36 557.85 200.79 557.51 199.54 557.92 198.77 558.98 198.77 560.3 199.54 561.36 200.79 561.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.36"
					y1="557.85"
					x2="200.79"
					y2="557.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.68"
					y1="558.69"
					x2="205.17"
					y2="558.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.17"
					y1="561.15"
					x2="209.68"
					y2="560.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.79"
					y1="561.77"
					x2="204.36"
					y2="561.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.91"
					y1="558.48"
					x2="204.18"
					y2="558.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.18"
					y1="560.8"
					x2="202.91"
					y2="560.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.91"
					y1="560.8"
					x2="202.91"
					y2="558.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.31"
					y1="617.12"
					x2="393.31"
					y2="603.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.31"
					y1="603.27"
					x2="430.92"
					y2="603.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.39"
					y1="617.12"
					x2="438.84"
					y2="617.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.84"
					y1="652.75"
					x2="385.39"
					y2="652.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.39"
					y1="652.75"
					x2="385.39"
					y2="599.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.84"
					y1="599.31"
					x2="438.84"
					y2="652.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.39"
					y1="600.3"
					x2="438.84"
					y2="600.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.92"
					y1="617.12"
					x2="430.92"
					y2="603.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.39"
					y1="599.31"
					x2="438.84"
					y2="599.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.39"
					y1="722.37"
					x2="760.68"
					y2="722.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.68"
					y1="722.37"
					x2="760.68"
					y2="724.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.68"
					y1="724.75"
					x2="765.39"
					y2="724.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="791.53"
					x2="772.82"
					y2="786.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="783.27"
					x2="772.82"
					y2="778.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="774.96"
					x2="772.82"
					y2="769.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="766.66"
					x2="772.82"
					y2="761.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="758.35"
					x2="772.82"
					y2="753.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="750.05"
					x2="772.82"
					y2="744.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="741.74"
					x2="772.82"
					y2="736.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="733.43"
					x2="772.82"
					y2="728.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="725.12"
					x2="772.82"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.82"
					y1="447.91"
					x2="772.82"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.31"
					y1="646.82"
					x2="430.92"
					y2="646.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.92"
					y1="646.82"
					x2="430.92"
					y2="621.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.92"
					y1="621.08"
					x2="393.31"
					y2="621.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.31"
					y1="621.08"
					x2="393.31"
					y2="646.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="768.5 631.97 768.5 696.87 824.74 696.87 824.74 631.97 768.5 631.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.5"
					y1="631.97"
					x2="768.5"
					y2="696.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.74"
					y1="631.97"
					x2="824.74"
					y2="696.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.04"
					y1="631.97"
					x2="823.04"
					y2="696.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.5"
					y1="631.97"
					x2="824.74"
					y2="631.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.5"
					y1="696.87"
					x2="824.74"
					y2="696.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.05"
					y1="636.23"
					x2="771.05"
					y2="692.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.05"
					y1="692.61"
					x2="772.76"
					y2="694.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.76"
					y1="694.31"
					x2="820.48"
					y2="694.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.48"
					y1="694.31"
					x2="822.19"
					y2="692.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.19"
					y1="692.61"
					x2="822.19"
					y2="636.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.19"
					y1="636.23"
					x2="820.48"
					y2="634.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.48"
					y1="634.52"
					x2="772.76"
					y2="634.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.76"
					y1="634.52"
					x2="771.05"
					y2="636.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m791.08,648.19c0-4.7-3.81-8.52-8.52-8.52s-8.52,3.81-8.52,8.52,3.81,8.52,8.52,8.52,8.52-3.81,8.52-8.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m817.07,648.19c0-3.53-2.86-6.39-6.39-6.39s-6.39,2.86-6.39,6.39,2.86,6.39,6.39,6.39,6.39-2.86,6.39-6.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m788.95,680.64c0-3.53-2.86-6.39-6.39-6.39s-6.39,2.86-6.39,6.39,2.86,6.39,6.39,6.39,6.39-2.86,6.39-6.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m819.2,680.64c0-4.71-3.81-8.52-8.52-8.52s-8.52,3.81-8.52,8.52,3.81,8.52,8.52,8.52,8.52-3.81,8.52-8.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="447.91"
					x2="798.78"
					y2="449.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="452.6"
					x2="798.78"
					y2="457.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="460.9"
					x2="798.78"
					y2="466.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="469.21"
					x2="798.78"
					y2="474.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="477.51"
					x2="798.78"
					y2="482.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="485.82"
					x2="798.78"
					y2="491.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="494.13"
					x2="798.78"
					y2="499.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="502.43"
					x2="798.78"
					y2="507.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="510.74"
					x2="798.78"
					y2="515.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="519.05"
					x2="798.78"
					y2="524.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="527.36"
					x2="798.78"
					y2="532.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="535.66"
					x2="798.78"
					y2="540.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="543.97"
					x2="798.78"
					y2="549.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="552.27"
					x2="798.78"
					y2="557.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="560.58"
					x2="798.78"
					y2="565.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="568.89"
					x2="798.78"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="577.2"
					x2="798.78"
					y2="582.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="585.5"
					x2="798.78"
					y2="590.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="593.81"
					x2="798.78"
					y2="599"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="602.12"
					x2="798.78"
					y2="607.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="610.42"
					x2="798.78"
					y2="615.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="618.73"
					x2="798.78"
					y2="623.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="627.04"
					x2="798.78"
					y2="632.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="635.34"
					x2="798.78"
					y2="640.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="643.65"
					x2="798.78"
					y2="648.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="651.96"
					x2="798.78"
					y2="657.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="660.26"
					x2="798.78"
					y2="665.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="668.57"
					x2="798.78"
					y2="673.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="676.88"
					x2="798.78"
					y2="682.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="685.19"
					x2="798.78"
					y2="690.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="693.49"
					x2="798.78"
					y2="698.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="701.8"
					x2="798.78"
					y2="706.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="710.1"
					x2="798.78"
					y2="715.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.78"
					y1="718.37"
					x2="798.78"
					y2="719.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="861.31 433.52 861.31 810.41 817.2 810.41 817.2 950 794.52 950 794.52 932.76 799.96 932.76 799.96 793.17 844.07 793.17 844.07 721.88 824.21 721.88 824.21 450.77 772.85 450.77 772.85 115.5 739.81 115.5 739.81 153.29 698.89 153.29 698.89 115.5 686.54 115.5 686.54 98.25 790.1 98.25 790.1 433.52 861.31 433.52"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.43"
				/>
				<polygon
					points="517.86 98.25 517.86 115.5 467.66 115.5 467.66 461.54 450.31 461.54 450.31 450.77 456.88 450.77 456.88 184.89 407.33 184.89 407.33 71.51 377.21 71.51 377.21 54.27 424.6 54.27 429.84 54.72 434.92 56.08 439.69 58.31 444 61.33 447.72 65.04 450.73 69.35 452.96 74.12 454.32 79.2 454.78 84.44 454.78 98.25 517.86 98.25"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.43"
				/>
				<polygon
					points="716.92 932.76 716.92 950 610.6 950 610.6 682.76 169.47 682.76 169.47 54.27 233.49 54.27 233.49 71.51 186.71 71.51 186.71 385.57 192.66 385.57 192.66 396.35 186.71 396.35 186.71 450.77 325.72 450.77 325.72 396.35 318.76 396.35 318.76 385.57 336.49 385.57 336.49 450.77 372.71 450.77 372.71 461.54 357.25 461.54 357.25 469.93 346.47 469.93 346.47 461.54 200.13 461.54 200.13 592.87 215.42 592.87 215.42 665.51 346.47 665.51 346.47 547.53 357.25 547.53 357.25 587.05 384.6 587.05 384.6 597.84 379.93 597.84 379.93 665.51 445.21 665.51 445.21 597.84 440.64 597.84 440.64 587.05 455.99 587.05 455.99 600.33 472.58 600.33 472.58 611.11 455.99 611.11 455.99 665.51 617.07 665.51 617.07 611.11 598.68 611.11 598.68 600.33 677.76 600.33 677.76 932.76 716.92 932.76"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.43"
				/>
			</g>
			<g id="text">
				<path d="m794.8,540.67v-10.13h3.49c.79,0,1.39.05,1.8.15.58.13,1.08.38,1.49.73.53.45.93,1.03,1.2,1.73.27.7.4,1.5.4,2.4,0,.77-.09,1.45-.27,2.05-.18.59-.41,1.09-.69,1.48-.28.39-.59.69-.93.92-.33.22-.73.39-1.21.5-.47.12-1.01.17-1.62.17h-3.66Zm1.34-1.2h2.16c.67,0,1.19-.06,1.57-.19.38-.12.69-.3.91-.53.32-.32.56-.74.74-1.28.18-.54.27-1.19.27-1.96,0-1.06-.18-1.87-.53-2.44-.35-.57-.77-.95-1.26-1.15-.36-.14-.94-.21-1.73-.21h-2.13v7.74Zm10.66,1.2l-2.69-10.13h1.38l1.54,6.64c.17.7.31,1.39.43,2.07.26-1.08.41-1.71.46-1.87l1.93-6.84h1.62l1.45,5.13c.36,1.27.63,2.47.79,3.59.13-.64.3-1.38.5-2.2l1.59-6.51h1.35l-2.78,10.13h-1.29l-2.14-7.72c-.18-.64-.29-1.04-.32-1.19-.11.47-.21.86-.3,1.19l-2.15,7.72h-1.37Z" />
				<path d="m796.04,759.33h-1.42l-1.71-2.86c-.16-.27-.31-.49-.46-.68-.15-.19-.3-.34-.46-.46-.15-.12-.32-.2-.5-.26-.18-.06-.37-.09-.6-.09h-.98v4.34h-1.2v-10.2h3.05c.45,0,.86.06,1.23.17.38.11.71.28.98.51.28.23.5.51.65.85.16.34.23.73.23,1.19,0,.36-.05.68-.16.98-.1.29-.26.56-.46.79-.19.23-.43.43-.71.6-.28.16-.59.29-.93.38v.03c.17.08.32.16.44.26.13.09.25.21.36.34.11.13.23.28.33.46.11.17.24.36.38.58l1.91,3.07Zm-6.12-9.12v3.7h1.62c.3,0,.57-.05.83-.14.26-.09.48-.22.66-.38.18-.17.33-.38.43-.62.1-.25.16-.52.16-.83,0-.55-.18-.97-.53-1.27-.35-.31-.86-.46-1.53-.46h-1.64Zm13.09,5.77h-5.14c.02.81.24,1.44.65,1.88.42.44.99.66,1.72.66.82,0,1.57-.27,2.26-.81v1.1c-.64.46-1.49.7-2.54.7s-1.84-.33-2.43-.99c-.59-.66-.88-1.6-.88-2.8,0-1.13.32-2.06.96-2.77.65-.72,1.44-1.07,2.4-1.07s1.69.31,2.21.93c.52.62.78,1.47.78,2.57v.61Zm-1.2-.99c0-.67-.17-1.2-.49-1.57-.32-.37-.76-.56-1.33-.56s-1.02.2-1.4.59c-.38.39-.62.91-.71,1.54h3.94Zm6.43-5.42c-.23-.13-.49-.19-.78-.19-.82,0-1.22.51-1.22,1.54v1.12h1.71v1h-1.71v6.29h-1.16v-6.29h-1.25v-1h1.25v-1.18c0-.76.22-1.37.66-1.81.44-.45.99-.67,1.65-.67.36,0,.64.04.85.13v1.05Z" />
				<path d="m809.48,759.49c-.22,0-.41-.08-.56-.23-.15-.16-.23-.34-.23-.56s.08-.41.23-.56c.16-.16.34-.24.56-.24s.41.08.57.24c.16.16.23.34.23.56s-.08.41-.23.56-.35.23-.57.23Z" />
				<path d="m266.49,564.44v-15.84h4.51c1.37,0,2.46.34,3.26,1,.8.67,1.2,1.54,1.2,2.62,0,.9-.24,1.68-.73,2.34-.49.66-1.16,1.13-2.01,1.41v.04c1.07.13,1.92.53,2.56,1.21.64.68.96,1.56.96,2.65,0,1.35-.49,2.45-1.46,3.29-.97.84-2.2,1.26-3.68,1.26h-4.62Zm1.86-14.16v5.11h1.9c1.02,0,1.81-.24,2.4-.73.58-.49.87-1.19.87-2.08,0-1.54-1.01-2.31-3.04-2.31h-2.13Zm0,6.78v5.7h2.52c1.09,0,1.93-.26,2.53-.77.6-.52.91-1.22.91-2.12,0-1.87-1.27-2.8-3.82-2.8h-2.13Zm18.96,7.38h-1.81v-1.77h-.04c-.79,1.35-1.95,2.03-3.48,2.03-1.13,0-2.01-.3-2.65-.89-.63-.6-.95-1.39-.95-2.37,0-2.11,1.24-3.34,3.73-3.69l3.39-.47c0-1.92-.78-2.88-2.33-2.88-1.36,0-2.59.46-3.69,1.39v-1.86c1.11-.71,2.39-1.06,3.84-1.06,2.66,0,3.99,1.41,3.99,4.22v7.35Zm-1.81-5.72l-2.73.38c-.84.12-1.47.33-1.9.63-.43.29-.64.82-.64,1.58,0,.55.2,1,.59,1.36.4.35.92.52,1.58.52.9,0,1.64-.31,2.22-.94.59-.63.88-1.43.88-2.4v-1.13Zm10.48,5.61c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.69h-1.94v-1.55h1.94v-2.76l1.81-.59v3.35h2.85v1.55h-2.85v6.37c0,.76.13,1.3.39,1.62.26.32.68.49,1.28.49.46,0,.85-.13,1.18-.38v1.55Zm11.81.11h-1.81v-6.52c0-2.36-.88-3.53-2.63-3.53-.88,0-1.63.34-2.23,1.03-.6.68-.91,1.55-.91,2.62v6.41h-1.81v-16.74h1.81v7.31h.04c.87-1.43,2.11-2.14,3.71-2.14,2.55,0,3.82,1.54,3.82,4.61v6.97Z" />
				<path d="m717.69,869.58h-8.39v-15.84h8.04v1.68h-6.18v5.27h5.72v1.67h-5.72v5.54h6.54v1.68Zm12.22,0h-1.81v-6.45c0-2.4-.88-3.6-2.63-3.6-.91,0-1.66.34-2.25,1.03-.59.68-.88,1.54-.88,2.57v6.45h-1.81v-11.31h1.81v1.88h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.84,1.2.66.8.98,1.95.98,3.46v6.91Zm8.68-.11c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.69h-1.94v-1.55h1.94v-2.76l1.81-.59v3.35h2.85v1.55h-2.85v6.37c0,.76.13,1.3.39,1.62s.68.49,1.28.49c.46,0,.85-.13,1.18-.38v1.55Zm8.34-9.36c-.32-.24-.77-.36-1.37-.36-.77,0-1.42.36-1.94,1.09-.52.73-.77,1.72-.77,2.98v5.76h-1.81v-11.31h1.81v2.33h.04c.26-.8.65-1.41,1.18-1.86.53-.45,1.12-.67,1.78-.67.47,0,.83.05,1.08.15v1.88Zm10.99-1.83l-5.2,13.12c-.93,2.34-2.23,3.51-3.91,3.51-.47,0-.87-.05-1.18-.14v-1.62c.39.13.75.2,1.07.2.91,0,1.6-.54,2.05-1.63l.91-2.14-4.42-11.29h2.01l3.06,8.7c.04.11.11.4.23.86h.07c.04-.18.11-.46.22-.84l3.21-8.72h1.88Z" />
				<path d="m265.98,248.5v-15.84h4.51c1.37,0,2.46.33,3.26,1,.8.67,1.2,1.54,1.2,2.62,0,.9-.24,1.68-.73,2.34-.49.66-1.16,1.13-2.01,1.41v.04c1.07.13,1.92.53,2.56,1.21.64.68.96,1.56.96,2.65,0,1.35-.49,2.45-1.46,3.29-.97.84-2.2,1.26-3.68,1.26h-4.62Zm1.86-14.16v5.11h1.9c1.02,0,1.81-.24,2.4-.73.58-.49.87-1.19.87-2.08,0-1.54-1.01-2.31-3.04-2.31h-2.13Zm0,6.78v5.7h2.52c1.09,0,1.93-.26,2.53-.77.6-.52.91-1.22.91-2.12,0-1.87-1.27-2.8-3.82-2.8h-2.13Zm19.93,2.18h-7.98c.03,1.26.37,2.23,1.02,2.92.65.68,1.54,1.03,2.67,1.03,1.27,0,2.44-.42,3.51-1.26v1.7c-.99.72-2.31,1.08-3.94,1.08s-2.85-.51-3.77-1.54c-.91-1.03-1.37-2.48-1.37-4.34,0-1.76.5-3.19,1.49-4.3,1-1.11,2.24-1.67,3.72-1.67s2.62.48,3.43,1.44c.81.96,1.21,2.29,1.21,3.99v.95Zm-1.86-1.54c0-1.05-.26-1.86-.76-2.44-.49-.58-1.18-.87-2.07-.87s-1.58.31-2.18.92c-.6.61-.96,1.41-1.1,2.4h6.11Zm14.23,6.74h-1.81v-1.92h-.04c-.84,1.46-2.14,2.19-3.89,2.19-1.42,0-2.56-.5-3.41-1.51-.85-1.02-1.27-2.4-1.27-4.14,0-1.87.47-3.37,1.41-4.49.94-1.13,2.2-1.69,3.77-1.69s2.68.61,3.39,1.83h.04v-7h1.81v16.74Zm-1.81-5.11v-1.67c0-.91-.3-1.69-.91-2.32-.6-.63-1.37-.95-2.3-.95-1.1,0-1.97.4-2.61,1.21-.63.81-.95,1.93-.95,3.36,0,1.3.3,2.33.91,3.09.61.75,1.43,1.13,2.45,1.13s1.83-.36,2.45-1.09c.63-.73.95-1.65.95-2.76Zm11.36-4.36c-.32-.24-.77-.36-1.37-.36-.77,0-1.42.36-1.94,1.09-.52.73-.77,1.72-.77,2.98v5.76h-1.81v-11.31h1.81v2.33h.04c.26-.8.65-1.41,1.18-1.86.53-.45,1.12-.67,1.78-.67.47,0,.83.05,1.08.15v1.88Zm6.68,9.74c-1.67,0-3.01-.53-4.01-1.58-.99-1.06-1.49-2.46-1.49-4.21,0-1.9.52-3.38,1.56-4.45,1.04-1.07,2.44-1.6,4.21-1.6s3,.52,3.94,1.56c.95,1.04,1.42,2.48,1.42,4.32s-.51,3.25-1.54,4.34c-1.02,1.08-2.38,1.62-4.1,1.62Zm.13-10.31c-1.16,0-2.08.4-2.76,1.19-.68.79-1.02,1.88-1.02,3.27s.34,2.4,1.03,3.17c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.84.95-3.24s-.32-2.5-.95-3.27c-.63-.77-1.52-1.15-2.69-1.15Zm13.11,10.31c-1.67,0-3.01-.53-4.01-1.58-.99-1.06-1.49-2.46-1.49-4.21,0-1.9.52-3.38,1.56-4.45,1.04-1.07,2.44-1.6,4.21-1.6s3,.52,3.94,1.56c.95,1.04,1.42,2.48,1.42,4.32s-.51,3.25-1.54,4.34c-1.02,1.08-2.38,1.62-4.1,1.62Zm.13-10.31c-1.16,0-2.08.4-2.76,1.19-.68.79-1.02,1.88-1.02,3.27s.34,2.4,1.03,3.17,1.6,1.16,2.75,1.16,2.07-.38,2.69-1.14c.63-.76.95-1.84.95-3.24s-.32-2.5-.95-3.27c-.63-.77-1.52-1.15-2.69-1.15Zm24.44,10.05h-1.81v-6.49c0-1.25-.2-2.16-.59-2.72-.38-.56-1.03-.84-1.94-.84-.77,0-1.43.35-1.98,1.06-.54.71-.81,1.55-.81,2.54v6.45h-1.81v-6.71c0-2.22-.86-3.34-2.57-3.34-.8,0-1.45.33-1.97,1-.52.66-.77,1.53-.77,2.6v6.45h-1.81v-11.31h1.81v1.79h.04c.8-1.37,1.97-2.05,3.51-2.05.77,0,1.45.22,2.02.65.57.43.97.99,1.18,1.69.84-1.56,2.09-2.34,3.75-2.34,2.49,0,3.73,1.54,3.73,4.61v6.97Z" />
				<path d="m270.5,271.98h-1.32v-9.95c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.39-.24.13-.5.25-.77.36-.27.11-.53.2-.79.27v-1.33c.29-.08.59-.19.92-.32.33-.14.65-.29.96-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.78Zm11.26-5.81c0,.96-.09,1.82-.27,2.56-.17.74-.42,1.37-.76,1.89-.33.51-.73.9-1.21,1.16-.48.26-1.02.39-1.63.39-.58,0-1.1-.13-1.55-.38-.45-.26-.83-.63-1.14-1.12-.31-.49-.55-1.08-.71-1.79-.16-.71-.24-1.53-.24-2.44,0-1.01.08-1.9.25-2.67.17-.77.42-1.42.75-1.94.33-.52.73-.92,1.21-1.18.49-.27,1.04-.4,1.67-.4,2.42,0,3.62,1.97,3.62,5.9Zm-1.35.13c0-3.28-.78-4.92-2.34-4.92-1.64,0-2.47,1.67-2.47,5,0,3.11.81,4.67,2.42,4.67s2.39-1.59,2.39-4.76Z" />
				<rect x="283.77" y="260.46" width="1.16" height="3.59" />
				<path d="m294.4,268.32c0,.56-.09,1.08-.27,1.55-.18.47-.43.88-.76,1.22-.32.34-.7.61-1.15.8-.44.19-.93.28-1.45.28-.58,0-1.1-.12-1.56-.36-.46-.24-.84-.59-1.16-1.04-.32-.46-.56-1.01-.72-1.66-.17-.65-.25-1.39-.25-2.21,0-1,.11-1.91.33-2.72.22-.82.54-1.52.95-2.1.41-.58.91-1.03,1.49-1.35s1.22-.47,1.94-.47c.79,0,1.43.11,1.91.33v1.25c-.59-.31-1.22-.46-1.88-.46-.51,0-.98.12-1.39.35-.41.23-.77.56-1.06.98-.29.42-.52.92-.68,1.52-.16.59-.23,1.26-.23,1.98h.03c.53-.96,1.41-1.44,2.63-1.44.5,0,.96.09,1.36.26.41.17.75.42,1.04.73.29.31.51.68.67,1.12.16.43.23.92.23,1.45Zm-1.35.17c0-.4-.05-.76-.15-1.08-.1-.32-.25-.59-.44-.82-.19-.22-.42-.4-.7-.51-.28-.12-.59-.18-.95-.18-.33,0-.63.06-.91.18-.28.12-.52.29-.72.51-.2.21-.36.46-.48.74-.11.28-.17.58-.17.89,0,.4.06.77.17,1.12.11.34.27.64.47.9.2.26.44.46.72.61.28.14.6.22.94.22s.63-.06.91-.18c.27-.13.51-.31.7-.53s.34-.49.45-.8c.11-.32.16-.66.16-1.04Z" />
				<path d="m297.55,260.46v3.59h-1.16v-3.59h1.16Zm2.67,0v3.59h-1.16v-3.59h1.16Z" />
				<path d="m313.38,263.75l-2.76,4.16,2.72,4.06h-1.53l-1.61-2.67c-.1-.17-.22-.37-.36-.63h-.03s-.15.26-.38.63l-1.65,2.67h-1.52l2.8-4.03-2.68-4.19h1.53l1.59,2.81c.12.21.23.42.35.64h.03l2.06-3.45h1.45Z" />
				<path d="m323.92,271.98h-1.32v-9.95c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.39-.24.13-.5.25-.77.36-.27.11-.53.2-.79.27v-1.33c.29-.08.59-.19.92-.32.33-.14.65-.29.96-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.78Zm9.27-8.5c0-.35-.06-.66-.17-.92-.11-.26-.26-.48-.45-.65-.19-.18-.41-.31-.67-.39-.26-.09-.54-.13-.84-.13-.26,0-.51.03-.76.1s-.49.17-.72.29c-.23.12-.46.27-.67.44-.21.17-.42.36-.6.57v-1.41c.37-.36.78-.63,1.24-.82.46-.19,1.02-.29,1.68-.29.47,0,.91.07,1.31.21.4.13.75.33,1.04.59.29.26.52.59.69.97.17.39.26.83.26,1.33,0,.46-.05.87-.16,1.24-.1.37-.26.72-.47,1.04-.21.33-.47.64-.8.94-.32.3-.7.61-1.13.92-.54.39-.99.71-1.34.99-.35.27-.63.53-.84.77-.2.24-.35.47-.43.71-.08.24-.12.51-.12.82h5.74v1.18h-7.11v-.57c0-.49.05-.93.16-1.3.11-.37.28-.73.53-1.07.25-.34.57-.67.96-1.01.4-.34.89-.72,1.47-1.14.42-.3.77-.59,1.04-.86.28-.27.51-.55.68-.82.17-.27.29-.55.36-.83.07-.28.11-.58.11-.9Z" />
				<rect x="337.19" y="260.46" width="1.16" height="3.59" />
				<path d="m347.26,268.72c0,.52-.1.99-.3,1.42-.19.42-.47.79-.83,1.09-.35.3-.78.53-1.28.7-.5.17-1.05.25-1.65.25-1.1,0-1.97-.21-2.62-.63v-1.41c.78.61,1.67.92,2.67.92.4,0,.76-.05,1.08-.15.33-.1.61-.25.84-.44.24-.19.42-.43.54-.7.13-.27.19-.58.19-.92,0-1.5-1.07-2.26-3.21-2.26h-.96v-1.12h.91c1.9,0,2.84-.71,2.84-2.12,0-1.31-.72-1.96-2.17-1.96-.81,0-1.58.27-2.29.82v-1.28c.73-.44,1.61-.66,2.62-.66.48,0,.92.07,1.31.2.39.13.73.32,1,.56.28.24.49.53.64.87.16.34.23.71.23,1.12,0,1.52-.77,2.49-2.3,2.92v.03c.39.04.75.14,1.08.29.33.14.62.33.86.57.24.24.43.51.56.84.14.32.21.67.21,1.05Z" />
				<path d="m350.97,260.46v3.59h-1.16v-3.59h1.16Zm2.67,0v3.59h-1.16v-3.59h1.16Z" />
				<path d="m694.96,625.27h-2.58l-6.12-7.24c-.23-.27-.37-.46-.42-.55h-.04v7.8h-1.86v-15.84h1.86v7.44h.04c.1-.16.24-.34.42-.54l5.92-6.9h2.31l-6.79,7.6,7.27,8.24Zm2.77-14.18c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.18h-1.81v-11.31h1.81v11.31Zm8.89-.11c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.69h-1.94v-1.55h1.94v-2.76l1.81-.59v3.35h2.85v1.55h-2.85v6.37c0,.76.13,1.3.39,1.62.26.32.68.49,1.28.49.46,0,.85-.13,1.18-.38v1.55Zm10.12-.41c-.87.52-1.9.78-3.09.78-1.61,0-2.92-.52-3.91-1.57-.99-1.05-1.48-2.41-1.48-4.09,0-1.86.53-3.36,1.6-4.48,1.07-1.13,2.49-1.7,4.27-1.7.99,0,1.87.18,2.63.55v1.86c-.84-.59-1.74-.88-2.69-.88-1.16,0-2.11.42-2.85,1.25-.74.82-1.1,1.91-1.1,3.26s.35,2.37,1.04,3.14c.7.77,1.63,1.15,2.8,1.15.99,0,1.91-.33,2.78-.98v1.72Zm12.12.52h-1.81v-6.52c0-2.36-.88-3.53-2.63-3.53-.88,0-1.63.34-2.23,1.03-.6.68-.91,1.55-.91,2.62v6.41h-1.81v-16.74h1.81v7.31h.04c.87-1.43,2.11-2.14,3.71-2.14,2.55,0,3.82,1.53,3.82,4.61v6.97Zm12.49-5.2h-7.98c.03,1.26.37,2.23,1.02,2.92.65.68,1.54,1.03,2.67,1.03,1.27,0,2.44-.42,3.51-1.26v1.7c-.99.72-2.31,1.08-3.94,1.08s-2.85-.51-3.77-1.54c-.91-1.03-1.37-2.48-1.37-4.34,0-1.76.5-3.19,1.49-4.3,1-1.11,2.24-1.67,3.72-1.67s2.62.48,3.43,1.44c.81.96,1.21,2.29,1.21,3.99v.95Zm-1.86-1.54c0-1.05-.26-1.86-.76-2.44-.49-.58-1.18-.87-2.07-.87s-1.58.31-2.18.92c-.6.61-.96,1.41-1.1,2.4h6.11Zm13.97,6.74h-1.81v-6.45c0-2.4-.88-3.6-2.63-3.6-.91,0-1.66.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.45h-1.81v-11.31h1.81v1.88h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.84,1.2.66.8.98,1.95.98,3.46v6.91Z" />
				<path d="m523.67,270.8h-8.22v-15.84h1.86v14.16h6.36v1.68Zm3.12-14.18c-.32,0-.6-.11-.83-.33s-.34-.5-.34-.84.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.18h-1.81v-11.31h1.81v11.31Zm12.55-11.31l-4.51,11.31h-1.78l-4.28-11.31h1.99l2.87,8.22c.21.6.35,1.13.4,1.58h.04c.07-.57.19-1.08.35-1.54l3-8.26h1.91Zm2.87-2.87c-.32,0-.6-.11-.83-.33s-.34-.5-.34-.84.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.18h-1.81v-11.31h1.81v11.31Zm13.04,0h-1.81v-6.45c0-2.4-.88-3.6-2.63-3.6-.91,0-1.66.34-2.25,1.03-.59.68-.88,1.54-.88,2.57v6.45h-1.81v-11.31h1.81v1.88h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.84,1.2.66.8.98,1.95.98,3.46v6.91Zm13.06-.91c0,4.15-1.99,6.23-5.96,6.23-1.4,0-2.62-.27-3.67-.8v-1.81c1.27.71,2.49,1.06,3.64,1.06,2.78,0,4.17-1.48,4.17-4.44v-1.24h-.04c-.86,1.44-2.16,2.16-3.89,2.16-1.41,0-2.54-.5-3.4-1.5-.85-1.01-1.28-2.36-1.28-4.05,0-1.92.46-3.45,1.38-4.58.93-1.13,2.19-1.7,3.8-1.7s2.65.61,3.39,1.83h.04v-1.57h1.81v10.4Zm-1.81-4.21v-1.67c0-.9-.31-1.67-.92-2.31-.6-.64-1.36-.96-2.26-.96-1.12,0-2,.41-2.63,1.23-.63.81-.95,1.95-.95,3.41,0,1.26.3,2.27.91,3.03.61.75,1.42,1.13,2.42,1.13s1.84-.36,2.47-1.08c.64-.72.96-1.65.96-2.77Z" />
				<polygon points="580.88 254.96 573.28 273.42 571.59 273.42 579.17 254.96 580.88 254.96" />
				<path d="m582.72,270.8v-15.84h4.37c5.58,0,8.37,2.57,8.37,7.72,0,2.44-.78,4.41-2.33,5.9-1.55,1.48-3.62,2.22-6.22,2.22h-4.2Zm1.86-14.16v12.48h2.36c2.08,0,3.69-.56,4.85-1.67,1.16-1.11,1.73-2.69,1.73-4.73,0-4.06-2.16-6.08-6.47-6.08h-2.47Zm14.62-.02c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.18h-1.81v-11.31h1.81v11.31Zm12.98,0h-1.81v-6.45c0-2.4-.88-3.6-2.63-3.6-.91,0-1.66.34-2.25,1.03-.59.68-.88,1.54-.88,2.57v6.45h-1.81v-11.31h1.81v1.88h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.84,1.2.66.8.98,1.95.98,3.46v6.91Zm4.28-14.18c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.18h-1.81v-11.31h1.81v11.31Zm12.98,0h-1.81v-6.45c0-2.4-.88-3.6-2.63-3.6-.91,0-1.66.34-2.25,1.03-.59.68-.88,1.54-.88,2.57v6.45h-1.81v-11.31h1.81v1.88h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.84,1.2.66.8.98,1.95.98,3.46v6.91Zm13-.91c0,4.15-1.99,6.23-5.96,6.23-1.4,0-2.62-.27-3.67-.8v-1.81c1.27.71,2.49,1.06,3.64,1.06,2.78,0,4.17-1.48,4.17-4.44v-1.24h-.04c-.86,1.44-2.16,2.16-3.89,2.16-1.41,0-2.54-.5-3.4-1.5-.85-1.01-1.28-2.36-1.28-4.05,0-1.92.46-3.45,1.38-4.58.93-1.13,2.19-1.7,3.8-1.7s2.65.61,3.39,1.83h.04v-1.57h1.81v10.4Zm-1.81-4.21v-1.67c0-.9-.31-1.67-.92-2.31-.6-.64-1.36-.96-2.26-.96-1.12,0-2,.41-2.63,1.23-.63.81-.95,1.95-.95,3.41,0,1.26.3,2.27.91,3.03.61.75,1.42,1.13,2.42,1.13s1.84-.36,2.47-1.08c.64-.72.96-1.65.96-2.77Z" />
				<path d="m665.87,270.8h-2.21l-2.65-4.44c-.24-.41-.48-.76-.71-1.05-.23-.29-.46-.53-.71-.72-.24-.18-.49-.32-.77-.4-.27-.09-.58-.13-.93-.13h-1.52v6.74h-1.86v-15.84h4.73c.69,0,1.33.09,1.91.26.59.17,1.1.43,1.52.78.43.35.77.8,1.02,1.33.24.52.36,1.14.36,1.84,0,.55-.08,1.06-.25,1.52-.16.46-.4.87-.71,1.23-.3.36-.67.67-1.1.93-.43.25-.91.45-1.45.59v.04c.26.12.49.25.68.41.2.15.39.32.56.53.18.21.35.44.52.71.18.26.37.56.59.91l2.97,4.76Zm-9.5-14.16v5.74h2.52c.46,0,.89-.07,1.28-.21.4-.14.74-.34,1.03-.6.29-.26.51-.59.67-.96.16-.38.24-.81.24-1.28,0-.85-.28-1.51-.83-1.98-.54-.48-1.34-.72-2.37-.72h-2.54Zm16.09,14.42c-1.67,0-3.01-.53-4.01-1.58-.99-1.06-1.49-2.46-1.49-4.21,0-1.9.52-3.38,1.56-4.45,1.04-1.07,2.44-1.6,4.21-1.6s3,.52,3.94,1.56c.95,1.04,1.42,2.48,1.42,4.32s-.51,3.25-1.54,4.34c-1.02,1.08-2.38,1.62-4.1,1.62Zm.13-10.31c-1.16,0-2.08.4-2.76,1.19-.68.79-1.02,1.88-1.02,3.27s.34,2.4,1.03,3.17c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.84.95-3.24s-.32-2.5-.95-3.27c-.63-.77-1.52-1.15-2.69-1.15Zm13.06,10.31c-1.67,0-3.01-.53-4.01-1.58-.99-1.06-1.49-2.46-1.49-4.21,0-1.9.52-3.38,1.56-4.45,1.04-1.07,2.44-1.6,4.21-1.6s3,.52,3.94,1.56c.95,1.04,1.42,2.48,1.42,4.32s-.51,3.25-1.54,4.34c-1.02,1.08-2.38,1.62-4.1,1.62Zm.13-10.31c-1.16,0-2.08.4-2.76,1.19-.68.79-1.02,1.88-1.02,3.27s.34,2.4,1.03,3.17c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.84.95-3.24s-.32-2.5-.95-3.27c-.63-.77-1.52-1.15-2.69-1.15Zm24.39,10.05h-1.81v-6.49c0-1.25-.2-2.16-.59-2.72-.38-.56-1.03-.84-1.94-.84-.77,0-1.43.35-1.98,1.06-.54.71-.81,1.55-.81,2.54v6.45h-1.81v-6.71c0-2.22-.86-3.34-2.57-3.34-.8,0-1.45.33-1.97,1-.52.66-.77,1.53-.77,2.6v6.45h-1.81v-11.31h1.81v1.79h.04c.8-1.37,1.97-2.05,3.51-2.05.77,0,1.45.22,2.02.65.57.43.97.99,1.18,1.69.84-1.56,2.09-2.34,3.75-2.34,2.49,0,3.73,1.54,3.73,4.61v6.97Z" />
				<path d="m573.07,294.28h-1.32v-9.95c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.39-.24.13-.5.25-.77.36-.27.11-.53.2-.79.27v-1.33c.29-.08.59-.19.92-.32.33-.14.65-.29.96-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.78Zm8.89,0h-1.32v-9.95c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.39-.24.13-.5.25-.77.36-.27.11-.53.2-.79.27v-1.33c.29-.08.59-.19.92-.32.33-.14.65-.29.96-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.78Z" />
				<rect x="586.34" y="282.76" width="1.16" height="3.59" />
				<path d="m596.82,287.83c0,1.05-.1,1.99-.31,2.82-.21.82-.51,1.52-.92,2.09-.4.57-.89,1-1.47,1.3-.58.29-1.24.44-1.98.44s-1.43-.13-2.01-.4v-1.26c.64.36,1.32.54,2.04.54.52,0,.98-.11,1.39-.32.41-.21.76-.52,1.04-.93.28-.41.5-.92.65-1.52s.22-1.29.22-2.06h-.03c-.49.99-1.35,1.49-2.57,1.49-.49,0-.95-.09-1.36-.26-.41-.18-.77-.42-1.07-.74-.3-.32-.53-.7-.7-1.14-.17-.44-.25-.92-.25-1.45,0-.57.09-1.09.27-1.56.19-.47.44-.88.77-1.21.33-.34.72-.61,1.17-.8.46-.19.95-.28,1.49-.28.58,0,1.09.12,1.53.35.45.23.83.57,1.13,1.02.31.44.54.99.7,1.65.16.65.24,1.4.24,2.24Zm-1.42-1.18c0-.44-.06-.85-.18-1.21-.11-.36-.27-.67-.47-.93-.2-.26-.45-.46-.73-.6-.28-.14-.58-.22-.92-.22s-.61.06-.88.19c-.27.12-.51.3-.71.53-.2.22-.36.5-.47.81-.11.31-.17.65-.17,1.02,0,.41.05.77.16,1.09.11.32.27.59.47.82.2.22.45.39.73.51.29.12.61.18.96.18.31,0,.59-.06.86-.17.27-.12.51-.27.71-.47.2-.2.36-.43.47-.69.12-.27.18-.55.18-.86Z" />
				<path d="m600.12,282.76v3.59h-1.16v-3.59h1.16Zm2.67,0v3.59h-1.16v-3.59h1.16Z" />
				<path d="m615.95,286.05l-2.76,4.16,2.72,4.06h-1.53l-1.61-2.67c-.1-.17-.22-.37-.36-.63h-.03s-.15.26-.38.63l-1.65,2.67h-1.52l2.8-4.03-2.68-4.19h1.53l1.59,2.81c.12.21.23.42.35.64h.03l2.06-3.45h1.45Z" />
				<path d="m626.49,294.28h-1.32v-9.95c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.39-.24.13-.5.25-.77.36-.27.11-.53.2-.79.27v-1.33c.29-.08.59-.19.92-.32.33-.14.65-.29.96-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.78Zm10.72-3.26c0,.52-.1.99-.3,1.42-.19.42-.47.79-.83,1.09-.35.3-.78.53-1.28.7-.5.17-1.05.25-1.65.25-1.1,0-1.97-.21-2.62-.63v-1.41c.78.61,1.67.92,2.67.92.4,0,.76-.05,1.08-.15.33-.1.61-.25.84-.44.24-.19.42-.43.54-.7.13-.27.19-.58.19-.92,0-1.5-1.07-2.26-3.21-2.26h-.96v-1.12h.91c1.9,0,2.84-.71,2.84-2.12,0-1.31-.72-1.96-2.17-1.96-.81,0-1.58.27-2.29.82v-1.28c.73-.44,1.61-.66,2.62-.66.48,0,.92.07,1.31.2s.73.32,1,.56c.28.24.49.53.64.87.16.34.23.71.23,1.12,0,1.52-.77,2.49-2.3,2.92v.03c.39.04.75.14,1.08.29.33.14.62.33.86.57.24.24.43.51.56.84.14.32.21.67.21,1.05h0Z" />
				<rect x="639.76" y="282.76" width="1.16" height="3.59" />
				<path d="m649.01,282.76v7.61h1.48v1.2h-1.48v2.71h-1.3v-2.71h-5.41v-1.14c.5-.57,1.01-1.17,1.53-1.82.51-.65,1-1.3,1.47-1.97.47-.66.91-1.33,1.3-1.98.4-.66.74-1.3,1.01-1.9h1.41Zm-5.23,7.61h3.93v-5.64c-.4.7-.78,1.33-1.14,1.88-.36.55-.7,1.05-1.03,1.5-.32.45-.63.86-.92,1.22-.29.36-.57.71-.84,1.04h0Z" />
				<path d="m653.54,282.76v3.59h-1.16v-3.59h1.16Zm2.67,0v3.59h-1.16v-3.59h1.16Z" />
				<path d="m410.08,626.48l-2.6,9.22h-1.27l-1.9-6.74c-.08-.29-.13-.6-.15-.94h-.03c-.03.32-.08.63-.17.93l-1.91,6.75h-1.25l-2.7-9.22h1.19l1.96,7.07c.08.3.13.6.15.93h.03c.02-.23.09-.54.2-.93l2.04-7.07h1.04l1.95,7.12c.07.24.12.53.15.86h.03c.02-.22.07-.52.17-.89l1.88-7.1h1.17Z" />
				<polygon points="415.18 626.48 410.76 637.23 409.77 637.23 414.18 626.48 415.18 626.48" />
				<path d="m426.24,628.96c-.26-.7-.66-1.28-1.2-1.73-.41-.35-.91-.59-1.49-.73-.41-.1-1.02-.15-1.8-.15h-3.49v10.13h3.66c.61,0,1.15-.06,1.62-.17.47-.12.88-.28,1.21-.5.34-.23.65-.53.93-.92.28-.39.51-.88.69-1.48.18-.59.27-1.28.27-2.05,0-.9-.13-1.7-.4-2.41Zm-1.25,4.34c-.18.53-.42.96-.74,1.28-.23.23-.53.4-.91.53-.38.12-.9.19-1.57.19h-2.16v-7.74h2.13c.8,0,1.38.07,1.73.21.5.19.92.58,1.26,1.15.35.57.53,1.38.53,2.44,0,.76-.09,1.42-.27,1.96Z" />
			</g>
		</g>
	)
}

export default PlanAA
